import styles from './css/healthmonitoringdetail.module.css'
import Floordeform from "./floordeform.js"
export default function Healthmonitoringdetail(props) {
  var damage = Object.values(props.event.damage);
  damage.reverse()
  var floor = damage.length;

  function scoretocolor(score) {
    if(score==null) return styles.damege_unknown
    else if(score < 0.5) return styles.damege0
    else if (score < 1.0) return styles.damege1
    else if (1.0 <= score) return styles.damege2
    else return styles.damege_unknown
  }

  return (
    <div className={styles.container}>
      <div></div><div></div><div></div><div></div><div></div><div></div>
      <div className={styles.block}><span className={styles.text}>外装</span></div>
      <div className={styles.block}><span className={styles.text}>間仕切壁</span></div>
      <div className={styles.block}><span className={styles.text}>天井</span></div>
      <div className={styles.block}><span className={styles.text}>設備機器</span></div>
      {damage.map((onedata,idx) => {
      return (
        <>
          <div></div>
          <div className={styles.itemb}><div className={styles.floor} style={{minHeight: "50px", maxHeight: "100px",height:"calc(((100vh - 500px) / " + damage.length + ")"}}>{(onedata.floor != undefined) ? onedata.floor : floor-idx+"F"}</div></div>
          <div className={styles.itemb}>
          {
            (onedata.body_x != undefined) ? <Floordeform point={onedata.body_x.value}/> : <Floordeform/>
          }
          </div>
          <div className={styles.itemb}></div>
          <div className={styles.itemb}>
          {
            (onedata.body_y != undefined) ? <Floordeform point={onedata.body_y.value}/> : <Floordeform/>
          }
          </div>
          <div></div>
          {
            (onedata.wall != undefined) ? <div className={`${styles.block} ${scoretocolor(onedata.wall.value)}`}><span className={styles.text}>{onedata.wall.text}</span></div>
            : <div className={`${styles.block} ${styles.damege_unknown}`}><span className={styles.text}>未判定</span></div>
          }
          {
            (onedata.partition != undefined) ? <div className={`${styles.block} ${scoretocolor(onedata.partition.value)}`}><span className={styles.text}>{onedata.partition.text}</span></div>
            : <div className={`${styles.block} ${styles.damege_unknown}`}><span className={styles.text}>未判定</span></div>
          }
          {
            (onedata.ceiling != undefined) ? <div className={`${styles.block} ${scoretocolor(onedata.ceiling.value)}`}><span className={styles.text}>{onedata.ceiling.text}</span></div>
            : <div className={`${styles.block} ${styles.damege_unknown}`}><span className={styles.text}>未判定</span></div>
          }
          {
            (onedata.equipment != undefined) ? <div className={`${styles.block} ${scoretocolor(onedata.equipment.value)}`}><span className={styles.text}>{onedata.equipment.text}</span></div>
            : <div className={`${styles.block} ${styles.damege_unknown}`}><span className={styles.text}>未判定</span></div>
          }
        </>
        )
      })}
      <div></div><div className={styles.padding}>&nbsp;</div><div className={styles.item}><div className={styles.theta2}>θ2</div><div className={styles.theta1}>θ1</div></div><div></div><div className={styles.item}><div className={styles.theta2}>θ2</div><div className={styles.theta1}>θ1</div></div><div></div><div></div><div></div><div></div><div></div>
      <div></div><div></div><div className={styles.itembold}>長手方向</div><div></div><div className={styles.itembold}>短手方向</div><div></div><div></div><div></div><div></div><div></div>
      <div className={styles.title1}>&lt;各階の層間変形角&gt;</div><div className={styles.title2}>&lt;各階の被害予測一覧&gt;</div>
      <div className={styles.title1block}>※θ1:部材の損傷限界変形角<br/>　θ2:躯体の安全限界変形角</div><div className={styles.title2}></div>
    </div>
  )
};